import React, { useContext } from 'react';
import axios from 'axios';
import { CotizadorContext } from '../../cotizador_one_personal/context';


const usePersonalData = () => {
    const [state, setState] = useContext(CotizadorContext)

    const getPersonalData = () => {
        return state.personal_data
    }
    
    const setPersonalData = async (personal_data) => {
        setState(prevState => ({
            ...prevState,
            personal_data: personal_data
        }))
        
        // Agregar el campo source para identificar que viene de Kinto
        const dataToSend = {
            ...personal_data,
            source: 'kinto'
        };
        
        if(state.personal_data.id !== 0) {
            await axios.put(`/api/kinto/forms/one_personal_update/${state.personal_data.id}/`, dataToSend, {
                headers: {
                    'X-CSRFToken': document.querySelector('meta[name="csrf-token"]').content
                }
            });
        } else {
            await axios.post('/api/kinto/forms/one_personal/', dataToSend, {
                headers: {
                    'X-CSRFToken': document.querySelector('meta[name="csrf-token"]').content
                }
            })
            .then(response => {
                const id = response.data.id
                personal_data.id = id
            })
        }
    }

    return {
        getPersonalData,
        setPersonalData
    };
}

export default usePersonalData;